import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { deepClone } from '@tenant/utility/helper/Utils';
import { getListWebhookRegistrationsQuery } from '../apis';
import { setFieldWebhookRegistration } from '..';
import queryKeys from '../constants/queryKeys';

const useGetListWebhookRegistrations = ({ pageSize, pageIndex, searchTerm, isActive }) => {
  const dispatch = useDispatch();

  const query = useQuery({
    queryKey: queryKeys.getList({ pageSize, pageIndex, searchTerm, isActive }),
    queryFn: () => getListWebhookRegistrationsQuery({ pageSize, pageIndex, searchTerm, isActive }),
  });

  useEffect(() => {
    const data = query?.data?.data;
    if (data) {
      dispatch(
        setFieldWebhookRegistration({
          field: 'list',
          value: deepClone(data),
        }),
      );
    }
  }, [query?.data, dispatch]);

  return query;
};

export default useGetListWebhookRegistrations;
